import React, { useState } from "react";
// import arrow from './../../assets/image/icon/Arrow - Left.svg'
// import dots from './../../assets/image/icon/dots.svg'
// import logout from './../../assets/image/icon/logout.svg'
// import admin from './../../assets/image/icon/admin.svg'
import { Link } from "react-router-dom";
import { tutorIcons } from "../../assets";
import ReturnModal from "../Generic/Modal/ReturnModal";

const ReturnHeader = ({name, children,styles, path, dots,margin,onClick, page,}) => {
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
 
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(false);
  };
  return (
    <>
      <div className={`flex justify-around relative items-center w-full ${margin ? margin : 'mt-[70px] md:mt-10'}`}>
        <Link onClick={onClick} className="p-2 cursor-pointer box-border" to={path}>
          {tutorIcons.arrow}
          {/* <img src={arrow} alt="main" /> */}
        </Link>
        {
          name && (<div className="font-bold text-[15px] md:text-[17]">{name}</div>)
        }
        {
        page && (<div className={styles ? styles : 'font-medium text-[20px] md:text-[24]' }>{page}</div>)
        }
        <div>
          {
            !dots ?
            
            <div
            className="p-2 cursor-pointer box-border"
            onClick={openVidModal}
            >
          {tutorIcons.dots}
          {/* <img src={dots} alt="main" /> */}
        </div> : null
        }
          </div>
          <div className="absolute top">
          <ReturnModal onClose={closeVidModal} isOpen={isVidModalOpen}>
            {children}
          </ReturnModal>
          </div>
          {/* absolute bg-white right-[50px] top-[100px] drop-shadow-lg rounded max-w-[140px] w-full min-w-[108px] sm:max-w-[180px] md:h-auto md:right-[100px] md:top-[80px] */}
      </div>
    </>
  );
};

export default ReturnHeader;
